<template>
  <div class="wrapper">
    <div class="title_wrapper">
      <div class="title">{{ year + '年' + month + '月' }}</div>
    </div>
    <div class="connect_wrapper">
      <div
        v-for="(item, index) in dayList"
        class="calendre_date"
        :class="{
          active_color: checkoutDate(item),
          is_Sunday: isSunday(item),
          is_Monday: isMonday(item, index)
        }"
        :style="{
          backgroundColor: item.bgc,
          color: item.checked ? '#FFFFFF' : '',
          opacity: item.bgc != framesTagColor && item.checked ? '0.4' : '1'
        }"
        :key="index"
        @click="checkoutDate(item) ? handlerMessage() : handerClicDate(item)"
      >
        {{ item.day }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      noSelectDateColor: 'rgba(0, 0, 0, 0.25)',
      monthDay: '', //这个月有多少天
      dayList: [], //每个月日期的集合
      firstDay: '', //这个月的一号是周几
      dateTitle: '', //年月标题
      year: '', //年
      month: '', //月
      isEditProps: false
    }
  },
  props: {
    title: String,
    beginTime: String,
    endTime: String,
    isEdit: Boolean
  },
  created() {
    this.init()
    //首先要根据时间 确定这个月有多少天
    //1号是星期几
    //哪些日期是可以点击的。哪些是不能点击的 开始时间前。结束时间后
    //点击的时候怎么确认点击的是当前这个点
    //根据不同的画面点击显示不同的颜色，
    //点击的时候传参数为画面对应的颜色，点位有个选中状态，被选中就展示class
  },
  mounted() {
    this.totalPlayDate() //统计可以选择的日期一共有多少天
  },
  destroyed() {
    //解决上一步再下一步播放日期叠加问题
    this.resetPlayDateNum()
  },
  computed: {
    ...mapState(['framesTagColor', 'framesList', 'totalPlayDateNum', 'selectDateList'])
  },
  watch: {
    selectDateList: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.$nextTick(() => {
          this.renderDate(newVal)
          this.computePlayDateNum()
        })
      },
      deep: true,
      immediate: true
    },
    isEdit: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.isEditProps = newVal
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations([
      'pushPlayDates',
      'delectPlayDates',
      'addPlayDateNum',
      'reducePlayDateNum',
      'resetPlayDateNum',
      'computePlayDateNum'
    ]),
    //初始化
    init() {
      this.getYearAndMonth(this.title)
      this.monthDay = this.getMonthDay(this.year, this.month)
      this.firstDay = this.getWeek(this.year, this.month)
      this.getDayList()
    },
    //点击日期事件
    handerClicDate(item) {
      //不是编辑状态不能修改
      if (!this.isEditProps) return
      //避免没有画面也能选择日期 isChecked如果有选中的则为true
      let isChecked = this.framesList.some(item => item.checked)
      if (!isChecked) {
        return this.$message.warning('请选择画面')
      }
      //避免点击空日期报错
      if (item) {
        if (!this.isReviseDate(item)) return
        //判断编辑是能否修改
        //判断是否存在颜色 不存在直接变色 变色的条件应该是存在才变色，不是点击再变色
        if (!item.bgc) {
          item.bgc = this.framesTagColor
          this.pushPlayDates(item)
          // item.checked = !item.checked
        } else {
          //这里判断的是如果存在颜色点击则颜色消失，好需要判断一次是否是跟当前画面颜色一致
          if (item.bgc == this.framesTagColor) {
            item.bgc = ''
            this.delectPlayDates(item)
            item.checked = false
          } else {
            this.$message.warning('该日期已被占用')
          }
        }
      }
    },
    //将传递进来的值改为年月格式
    getYearAndMonth(value) {
      let arr = value.split('-')
      this.year = arr[0]
      this.month = +arr[1]
    },
    //判断月份有多少天
    getMonthDay(year, month) {
      let days = new Date(year, month, 0).getDate()
      return days
    },
    //判断1号是星期几
    getWeek(year, month) {
      var d = new Date()
      d.setYear(year)
      d.setMonth(month - 1)
      d.setDate(1)
      let week = d.getDay()
      return week
    },
    //根据1号使星期几得到渲染视图的数据
    getDayList() {
      let dayList = []
      for (let i = 1; i <= this.monthDay; i++) {
        dayList.push({
          day: i + '',
          month: this.month,
          year: this.year,
          checked: false,
          bgc: '',
          date:
            this.year +
            '-' +
            this.month.toString().padStart(2, '0') +
            '-' +
            (i + '').toString().padStart(2, '0')
        })
      }
      //周日0  加6空//周六6  加5空//周五5  加4空
      let num = this.firstDay ? this.firstDay - 1 : 6
      let i = 0
      while (i < num) {
        dayList.splice(0, 0, '')
        i++
      }
      this.dayList = [...dayList]
    },
    //判断日期是否可选择
    checkoutDate(item) {
      if (!item) return
      let status = false
      let startTime = new Date(this.beginTime).getTime()
      let endTime = new Date(this.endTime).getTime()
      let currentTime = new Date(item.date).getTime()
      //如果今当前的时间小于开始时间或者大于结束时间
      //2021/06/25  1624550400000 this.endTime
      //2021-06-25  1624579200000 item.date
      //格式不一样毫秒值不对
      if (currentTime < startTime || currentTime > endTime) {
        status = true
      }
      item.status = !status
      //知道开始和结束时间
      return status
    },
    //当点击不可用日期时候触发
    handlerMessage() {
      if (!this.isEditProps) return
      this.$message.warning('不可选择该日期')
    },
    //全选
    checkeAll() {
      this.dayList.forEach(item => {
        if (item && !this.isReviseDate(item, 1)) {
          //不能选择之前或者今天的日期
        } else if (!item.checked && item && !this.checkoutDate(item)) {
          item.bgc = this.framesTagColor
          this.pushPlayDates(item)
          item.checked = !item.checked
        }
      })
    },
    //取消全选
    deselectAll() {
      this.dayList.forEach(item => {
        //被选择的，并且是存在的不是前面那种占位，并且是在可选时间内的并且背景颜色和当前画面一致
        if (item && !this.isReviseDate(item, 1)) {
          //不能取消选择之前或者今天的日期
        } else if (
          item.checked &&
          item &&
          !this.checkoutDate(item) &&
          item.bgc == this.framesTagColor
        ) {
          item.bgc = ''
          this.delectPlayDates(item)
          item.checked = !item.checked
        }
      })
    },
    //统计可以选择的日期一共有多少天
    totalPlayDate() {
      this.dayList.forEach(item => {
        if (item.status) {
          this.addPlayDateNum()
        }
      })
    },
    //选择的日期改变视图
    renderDate(renderDate) {
      const dateList = renderDate.map(i => i.date)
      this.dayList.forEach(item => {
        //避免循环到占位时报错
        if (item) {
          //处理选择的日期
          if (dateList.includes(item.date)) {
            let obj = renderDate.filter(j => {
              return item.date == j.date
            })[0]
            item.bgc = obj.bgc
            item.checked = true
          } else {
            item.bgc = ''
            item.checked = false
          }
        }
      })
    },
    //判断是不是周日
    isSunday(item) {
      let dt = new Date(item.date)
      return dt.getDay() == 0
    },
    isMonday(item, index) {
      if (!item && index == 0) return true

      let dt = new Date(item.date)
      return dt.getDay() == 1
    },
    //是否能编辑日期
    // type 0 单机
    // type 1 全选/取消全选
    isReviseDate(item, type = 0) {
      //过去时间不能修改 待播放能修改今天开始 播放中只能修改明天开始
      let isPlay = this.framesList.some(i => i.isPlay)
      let todayTime = new Date().getTime()
      let itemTime = new Date(item.date).setHours(0)
      if (isPlay && todayTime > itemTime) {
        type || this.$message.warning('订单投放中不能修改包括今天之内的日期')
        return false
      }
      //订单状态为
      if (todayTime - itemTime > 86400000) {
        type || this.$message.warning('不能修改今天之前的日期')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 0 14px 0 14px;
  .title_wrapper {
    .title {
      // width: 77px;
      padding: 8px 0;
      height: 38px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: px;
    }
  }
  .connect_wrapper {
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;
    // .active_data_color{
    //   background-color: pink;
    // }
    .calendre_date {
      margin: 4px;
      height: 32px;
      width: 32px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      user-select: none;
      border-radius: 50%;
    }
    .active_color {
      color: rgba(0, 0, 0, 0.25);
    }
    .is_Sunday {
      margin-right: 0;
    }
    .is_Monday {
      margin-left: 0;
    }
  }
}
</style>
